import React from 'react';
import VStack from './components/VStack';

const Privacy = () => {
  return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
<VStack style={{paddingLeft:40,paddingRight:40,maxWidth:800}}>
        <h1 style={{marginTop:100}}>Privacy Policy</h1>

<h2 style={{marginTop:20}}>Last Updated: August 12,2024</h2>

We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application (the "App").


<h2  style={{marginTop:20}}>Information We Collect</h2>

Our App does not collect any personal information about you. We do not ask for, access, or track any location-based information, device identifiers, or other personally identifiable information. We do not use cookies or similar technologies to collect data.

<h2  style={{marginTop:20}}>How We Use Information</h2>

Since we do not collect any personal information, we do not use or process any data that can identify you as an individual.

<h2  style={{marginTop:20}}>How We Share Information</h2>

We do not share any personal information with third parties because we do not collect any personal information.

<h2  style={{marginTop:20}}>Data Retention</h2>

We do not retain any personal information because we do not collect any personal information.

<h2  style={{marginTop:20}}>Security</h2>

While we do not collect or store any personal information, we still take security measures to protect the integrity of our App. We regularly monitor our systems for possible vulnerabilities and attacks.

<h2  style={{marginTop:20}}>Third-Party Services</h2>

Our App does not use any third-party services that collect, monitor, or analyze data.

<h2  style={{marginTop:20}}>Changes to This Privacy Policy</h2>

We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.

<h2  style={{marginTop:20}}>Contact Us</h2>
<div style={{marginBottom:100}}>
If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at info@catnap.rest

By using the App, you consent to this Privacy Policy.
</div>
</VStack>
    </div>
  );
}

export default Privacy;